<template>
    <div>
        <button @click="changeStatus(1)"
                class="btn btn-success b-discussions__change-status"
        >
            <span v-show="!showLoader1" v-text="trans('apply_button')"></span>
            <div class="la-ball-fall" v-show="showLoader1"><div></div><div></div><div></div></div>
        </button>
        <button @click="changeStatus(2)"
                class="btn btn-danger b-discussions__change-status"
        >
            <span v-show="!showLoader2" v-text="trans('reject_button')"></span>
            <div class="la-ball-fall" v-show="showLoader2"><div></div><div></div><div></div></div>
        </button>
    </div>
</template>

<script>
    import * as Functions from '../Functions';

    export default {
        props: ['translations'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        data: function () {
            return {
                showLoader1: false,
                showLoader2: false,
                checked: []
            };
        },
        methods: {
            trans(name, path = 'communication') {
                return Functions.trans(this.translations, name, path);
            },
            changeStatus: function (status) {
                if (this.checked.length == 0) {
                    return this.discussionsNotFound();
                }

                this.switchShowLoader(status);
                let data = this.preparePostData(status);
                this.$http.post('/communication/discussions/change_status', data);

                this.updateTable(status);
            },
            discussionsNotFound: function () {
                alert(this.trans('items_not_selected'));
            },
            switchShowLoader: function (status) {
                status == 1
                    ? this.showLoader1 = !this.showLoader1
                    : this.showLoader2 = !this.showLoader2;
            },
            updateTable: function (status) {
                let obj = this;
                setTimeout(function () {
                    obj.$root.$emit('update-table');
                    obj.switchShowLoader(status);
                }, 1000);
            },
            preparePostData: function (status) {
                return {
                    ids: this.checked,
                    status: status
                };
            }
        },
        created: function () {
            this.$root.$on('update:checked', (val) => { this.checked = val});
        }
    }
</script>
